<template>
  <div v-loading="loading">
    <vxe-toolbar id="boxMakingArea">
      <template v-slot:buttons>
        <el-button @click="init">重置</el-button>
        <el-button @click="funcSave">提交</el-button>
      </template>
    </vxe-toolbar>
    <div class="main">
      <ul class="name">
        <li>姓名</li>
        <li>准驾车型</li>
        <li>驾驶证发证机关</li>
        <li>驾驶证有效期自</li>
        <li>驾驶证有效期至</li>
        <li>从业资格证号</li>
        <li>地址</li>
        <li>道路运输经营许可证号</li>
        <li>统一社会信用代码</li>
        <li>车队名称</li>
      </ul>
      <ul v-if="JSON.stringify(form) != '{}'" class="driver">
        <li>{{ form.name }}</li>
        <li>{{ form.vehicleClass }}</li>
        <li>{{ form.issuingOrganizations }}</li>
        <li>{{ form.driverLicenseFromDate }}</li>
        <li>{{ form.driverLicenseDueDate }}</li>
        <li>{{ form.workLicense }}</li>
        <li>{{ form.homeAddress }}</li>
        <li>{{ form.roadPermitNumber }}</li>
        <li>{{ form.businessLicenseNumber }}</li>
        <li>{{ form.linkMan }}</li>
      </ul>
      <template v-if="data && data.length > 0">
        <ul v-for="(item, index) in data" :key="index" class="object" @click="changeValue($event)">
          <li data-attr="name">{{ item.name }}</li>
          <li data-attr="vehicleClass">{{ item.vehicleClass }}</li>
          <li data-attr="issuingOrganizations">{{ item.issuingOrganizations }}</li>
          <li data-attr="driverLicenseFromDate">{{ item.driverLicenseFromDate }}</li>
          <li data-attr="driverLicenseDueDate">{{ item.driverLicenseDueDate }}</li>
          <li data-attr="workLicense">{{ item.workLicense }}</li>
          <li data-attr="homeAddress">{{ item.homeAddress }}</li>
          <li data-attr="roadPermitNumber">{{ item.roadPermitNumber }}</li>
          <li data-attr="businessLicenseNumber">{{ item.businessLicenseNumber }}
          </li>
          <li data-attr="linkMan">{{ item.linkMan }}</li>
        </ul>
      </template>

    </div>
  </div>
</template>
<script>
	import {
		driverInfor,
		rainbowDriverSave
	} from "@/api/driver";
	export default {
		name: "DriverDetail",
		data() {
			return {
				form: {},
				emptyForm: {},
				data: [],
				codes: '',
				loading: false
			}
		},
		methods: {
			init() {
				this.form = JSON.parse(JSON.stringify(this.emptyForm))
			},
			funcInit() {
				this.$set(this, 'form', {})
				this.$set(this, 'emptyForm', {})
				this.$set(this, 'data', [])
			},
			changeValue(e) {
				if (e.target.dataset.attr && e.target.innerText) {
					this.$set(this.form, `${e.target.dataset.attr}`, e.target.innerText)
				}
			},
			getDriver(code, type) {
				this.loading = true
				driverInfor({
					code: code,
					driverType: type
				}).then(res => {
					this.$set(this, 'form', res.data.driver)
					this.$set(this, 'data', res.data.driverRainbows)
					this.emptyForm = JSON.parse(JSON.stringify(this.form))
					this.loading = false
				})
			},
			funcSave() {
				this.$confirm('确认提交吗？')
					.then(_ => {
						this.form.codes = this.data.map(item => item.code).join(',');
						this.loading = true
						rainbowDriverSave(this.form).then(response => {
							this.$message({
								message: response.msg,
								type: 'success'
							});
							this.loading = false
							this.$emit('fatherMethods')
						}).catch( err => {
							this.loading = false
						})
					})
					.catch(_ => {});
			},
		}
	};
</script>
<style scoped lang="scss">
	ul,
	li {
		padding: 0;
		margin: 0;
		list-style: none
	}

	.main {
		width: 100%;
		overflow-x: auto;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		border: 1px solid #ebeef5;

		ul {
			min-width: 200px;

			li {
				height: 54px;
				line-height: 54px;
				min-width: 0;
				border-bottom: 1px solid #ebeef5;
				box-sizing: border-box;
				text-overflow: ellipsis;
				vertical-align: middle;
				position: relative;
				text-align: center;
			}

			li:last-child {
				border-bottom: none;
			}
		}

		ul {
			border-right: 1px solid #ebeef5;
		}

		.object li {
			cursor: pointer;
		}

		.name {
			position: sticky;
			left: 0;
			background-color: #f8f8f9;
			z-index: 9;
		}

		.driver {
			position: sticky;
			left: 200px;
			background-color: #f8f8f9;
			z-index: 9
		}
	}
</style>
